import React from "react";

const Home=()=>{

    return(
        <div>
           <div>
            <h2>React JS CRUD using REDUX & NODE JS</h2>
        </div>
        </div>

    );

}
export default Home;